import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CardWrap from "../Common/CardWrap";
import { priceListServices } from "../../Services";
import ResultModal from "../Common/ResultModal";

const EditPriceList = ({ match }) => {
  const initState = {
    tenantId: 1,
    name: "",
  };
  const [resultModal, setResultModal] = useState({
    title: "",
    text: "",
    show: false,
    btnClass: "",
    success: true,
  });
  const history = useHistory();
  const { t: translator } = useTranslation();

  const { register, handleSubmit, errors } = useForm();
  const [priceList, setPriceList] = useState(initState);

  const selectedPriceListId = match.params.priceListId;

  React.useEffect(() => {
    if (selectedPriceListId) {
      priceListServices.getById(selectedPriceListId).then((data) => {
        setPriceList({
          priceListId: data.data.priceListId,
          name: data.data.name,
        });
      });
    }
  }, []);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setPriceList({ ...priceList, [name]: value });
  };

  const onSubmit = (data) => {
    if (selectedPriceListId) {
      priceListServices
        .update({
          priceListId: selectedPriceListId,
          name: priceList.name,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditPriceList-Update-SuccessModal-Title"),
                text: translator("EditPriceList-Update-SuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditPriceList-Update-UnsuccessModal-Title"),
                text: translator("EditPriceList-Update-UnsuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditPriceList-Update-UnsuccessModal-Title"),
            text: translator("EditPriceList-Update-UnsuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    } else {
      priceListServices
        .create({
          tenantId: priceList.tenantId && parseInt(priceList.tenantId),
          name: priceList.name,
        })
        .then((res) => {
          res.data.success
            ? setResultModal({
                show: true,
                title: translator("EditPriceList-Add-SuccessModal-Title"),
                text: translator("EditPriceList-Add-SuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: true,
              })
            : setResultModal({
                show: true,
                title: translator("EditPriceList-Add-UnsuccessModal-Title"),
                text: translator("EditPriceList-Add-UnsuccessModal-Text"),
                btnClass: "btn btn-primary",
                success: false,
              });
        })
        .catch((err) =>
          setResultModal({
            show: true,
            title: translator("EditPriceList-Add-UnsuccessModal-Title"),
            text: translator("EditPriceList-Add-UnsuccessModal-Text"),
            btnClass: "btn btn-primary",
            success: false,
          })
        );
    }
  };

  const goBack = () => {
    history.push("/price-list");
  };

  const handleCloseResultModal = () => {
    setResultModal({ show: false });
    if (resultModal.success === true) {
      goBack();
    }
  };

  const handleCancel = () => {
    history.push("/price-list");
  };

  return (
    <CardWrap
      title={translator("EditPriceList-Title")}
      subtitle={translator("EditPriceList-Subtitle")}
    >
      <form onSubmit={handleSubmit(onSubmit)} className="row">
        <div className="col-lg-6">
          <fieldset className="scheduler-border">
            <legend className="scheduler-border">
              {(selectedPriceListId &&
                translator("EditPriceList-Legend-PriceListEditing")) ||
                translator("EditPriceList-Legend-NewPriceList")}
            </legend>

            <div className="form-group">
              <label>{translator("EditPriceList-Name")}</label>
              <input
                type="text"
                className="form-control"
                name="name"
                defaultValue={priceList.name}
                onChange={handleInputChange}
              />
            </div>
          </fieldset>
        </div>

        <div
          className="container-fluid"
          style={{ display: "flex", justifyContent: "flex-end" }}
        >
          <button className="btn btn-outline-secondary" onClick={handleCancel}>
            {translator("Btn-Cancel")}
          </button>
          &nbsp;
          <button className="btn btn-primary" type="submit">
            {translator("Btn-Save")}
          </button>
        </div>
      </form>
      <ResultModal
        show={resultModal.show}
        title={resultModal.title}
        text={resultModal.text}
        btnClass={resultModal.btnClass}
        handleClose={handleCloseResultModal}
      />
    </CardWrap>
  );
};

export default EditPriceList;
